import React, { useState } from "react";
import axios from "axios";

const colors = {
  mainBlue: "#061941",
  xanthous: "#F2AF29",
  isabelline: "#F4F3EE",
  carrieban: "#3C6E71",
  muted: "#6B7280",
};

function ContactModal({ professor, isOpen, onClose, onMessageSent }) {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const userData = JSON.parse(localStorage.getItem("user")) || {};
  const token = userData.token;

  const handleSendMessage = async () => {
    if (!message.trim()) {
      setError("Please enter a message");
      return;
    }

    if (message.length > 1000) {
      setError("Message must be less than 1000 characters");
      return;
    }

    try {
      setSending(true);
      setError("");

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/messages`,
        {
          recipientId: professor._id,
          content: message,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Clear form and close modal
      setMessage("");
      onMessageSent();
      onClose();
    } catch (err) {
      console.error("Error sending message:", err);
      setError("Failed to send message. Please try again.");
    } finally {
      setSending(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          maxWidth: "500px",
          width: "90%",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px",
            borderBottom: `1px solid ${colors.mainBlue}20`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: colors.mainBlue,
            color: "white",
          }}
        >
          <div>
            <h2
              style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: 600 }}
            >
              Contact {professor.name}
            </h2>
            <p style={{ margin: 0, fontSize: "12px", opacity: 0.9 }}>
              {professor.email}
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "white",
              fontSize: "24px",
              cursor: "pointer",
              padding: 0,
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div
          style={{
            padding: "20px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <p
            style={{
              margin: "0 0 12px 0",
              color: colors.muted,
              fontSize: "14px",
            }}
          >
            Send a message to introduce yourself and express your interest.
          </p>

          {/* Message Input */}
          <textarea
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setError("");
            }}
            placeholder="Write your message here..."
            style={{
              flex: 1,
              padding: "12px",
              border: `1px solid ${colors.mainBlue}30`,
              borderRadius: "6px",
              fontSize: "14px",
              fontFamily: "inherit",
              resize: "none",
              marginBottom: "8px",
              minHeight: "150px",
            }}
          />

          {/* Character Count */}
          <div
            style={{
              fontSize: "12px",
              color: message.length > 900 ? colors.xanthous : colors.muted,
              marginBottom: "12px",
              textAlign: "right",
            }}
          >
            {message.length}/1000
          </div>

          {/* Error Message */}
          {error && (
            <div
              style={{
                padding: "8px 12px",
                backgroundColor: "#FEE2E2",
                color: "#DC2626",
                borderRadius: "4px",
                fontSize: "13px",
                marginBottom: "12px",
              }}
            >
              {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "16px 20px",
            borderTop: `1px solid ${colors.mainBlue}20`,
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            disabled={sending}
            style={{
              padding: "8px 20px",
              backgroundColor: colors.isabelline,
              color: colors.mainBlue,
              border: `1px solid ${colors.mainBlue}30`,
              borderRadius: "4px",
              cursor: sending ? "not-allowed" : "pointer",
              fontSize: "14px",
              fontWeight: 600,
              opacity: sending ? 0.5 : 1,
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSendMessage}
            disabled={sending || !message.trim()}
            style={{
              padding: "8px 20px",
              backgroundColor: colors.carrieban,
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: sending || !message.trim() ? "not-allowed" : "pointer",
              fontSize: "14px",
              fontWeight: 600,
              opacity: sending || !message.trim() ? 0.5 : 1,
            }}
          >
            {sending ? "Sending..." : "Send Message"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContactModal;
